import ApiService from "@/common/api.service";
import JwtService from "@/common/jwt.service";
import { LOGIN, LOGOUT, CHECK_AUTH, FETCH_CURRENT_USER } from "./actions.type";
import {
  SET_AUTH,
  PURGE_AUTH,
  SET_ERROR,
  SET_CURRENT_USER
} from "./mutations.type";
import PermissionsService from "../common/permission.service";
import { ROLE_SUPER_ADMIN } from "../common/permissions";

const state = {
  errors: null,
  user: {
    roles: []
  },
  isAuthenticated: !!JwtService.getToken()
};

const getters = {
  currentUser: state => state.user,
  isAuthenticated: state => state.isAuthenticated,
  hasPermission(state) {
    return permission =>
      state.user.roles.filter(item => {
        return item === permission || item === ROLE_SUPER_ADMIN;
      }).length !== 0;
  },
  allPermissions: () => PermissionsService.getAll()
};

const actions = {
  [LOGIN](context, credentials) {
    return ApiService.post("login_check", {
      username: credentials.username,
      password: credentials.password
    }).then(({ data }) => {
      context.commit(SET_AUTH, data.token);
    });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },
  [CHECK_AUTH](context) {
    return new Promise((resolve, reject) => {
      if (JwtService.getToken()) {
        ApiService.setHeader();

        resolve();
      } else {
        context.commit(PURGE_AUTH);

        reject(new Error("Logged out!"));
      }
    });
  },
  [FETCH_CURRENT_USER](context) {
    return ApiService.get("me").then(({ data }) => {
      context.commit(SET_CURRENT_USER, data);
    });
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, token) {
    state.isAuthenticated = true;
    state.errors = {};
    JwtService.saveToken(token);
    ApiService.setHeader();
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    JwtService.destroyToken();
  },
  [SET_CURRENT_USER](state, user) {
    state.user = user;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
